import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';

const SENSITIVE_PATHS = ['/auth', '/account'];

function isSensitivePath(): boolean {
    if (typeof window === 'undefined') return false;
    const path = window.location.pathname.toLowerCase();
    return SENSITIVE_PATHS.some((p) => path.includes(p));
}

export const NoCacheInterceptor: HttpInterceptorFn = (req, next) => {
    return next(req).pipe(
        map((event) => {
            if (!(event instanceof HttpResponse) || !isSensitivePath()) return event;

            const headers = event.headers
                .set('Cache-Control', 'no-store, no-cache, must-revalidate, private')
                .set('Pragma', 'no-cache')
                .set('Expires', '0');

            return event.clone({ headers });
        }),
    );
};
